/**
 * Pure helpers for CeoCircleForm (no React, no redux).
 */

export const MAX_PHOTO_BYTES = 8 * 1024 * 1024;
export const MIN_YEAR = 1990;
export const CITATION_MAX = 120;

// Turns the data: URI the BHR endpoint returns into a file so it travels as a normal "photo".
export const dataUriToFile = (uri) => {
  const m = /^data:([^;,]+);base64,(.*)$/.exec(uri || "");
  if (!m) return null;
  const bin = atob(m[2]);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  const ext = m[1] === "image/png" ? "png" : m[1] === "image/webp" ? "webp" : "jpg";
  try {
    return new File([bytes], "bhr-photo." + ext, { type: m[1] });
  } catch (e) {
    return new Blob([bytes], { type: m[1] });
  }
};

// A 422 carries error_response($errors->all()) — a flat list, a string, or (defensively) a keyed object.
export const messagesOf = (error) => {
  const msg = error && error.data && error.data.error ? error.data.error.message : null;
  if (Array.isArray(msg)) return msg;
  if (msg && typeof msg === "object") return [].concat(...Object.values(msg));
  return msg ? [String(msg)] : ["The awardee could not be saved."];
};

// The one 422 the client cannot pre-check. Server text (CeoCircleRequest):
// "This employee is already in the CEO Circle for that year."
export const isDuplicateMessage = (message) => /already in the CEO Circle/i.test(String(message || ""));

export const initialState = (awardee, currentYear) => ({
  userId: awardee ? awardee.user_id : null,
  name: awardee ? awardee.name || "" : "",
  year: awardee ? String(awardee.year) : String(currentYear),
  jobTitle: awardee ? awardee.job_title || "" : "",
  citation: awardee ? awardee.citation || "" : "",
  options: null, // null = picker closed, [] = searched and nothing matched
  activeIndex: -1, // keyboard-highlighted picker row (-1 = none)
  serverErrors: [], // every message of the last 422, shown at the top of the form
  photoFile: null, // File / Blob chosen in this session (upload or BHR)
  photoPreview: awardee && awardee.photo_url ? awardee.photo_url : null,
  removePhoto: false,
  photoMsg: awardee && awardee.photo_url ? "Using the current photo." : "No photo yet. The poster will show initials.",
  posY: awardee && awardee.photo_pos_y != null ? awardee.photo_pos_y : 30,
  zoom: awardee && awardee.photo_zoom != null ? awardee.photo_zoom : 108,
  errors: {},
});
